/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  Text,
  LinkWrapper,
} from 'athenaeum';

import sharedStyles from '../menu.module.scss';
import styles from './primary_menu_header.module.scss';
import Submenu from '../../Submenu';
import { trackNavigate } from '../../utils/analytics';

function PrimaryMenuHeader(props) {
  const {
    activePrimaryTab,
    setActivePrimaryTab,
    activeName,
    header,
    submenu,
    subMenuSecondaryBackground, // Experiment CH28357 -- Remove this line if experiment loses
    href,
    ...otherProps
  } = props;

  const isActive = activePrimaryTab === activeName;
  const aboutHeader = activeName === 'about';

  const headerClasses = classnames(
    styles['primary-menu-header'],
    (isActive || otherProps.showMobileMenu) && styles['primary-menu-header-dark'],
    aboutHeader && styles['primary-menu-header-about'],
  );

  return (
    <React.Fragment>
      {
        href ? (
          <LinkWrapper
            href={href}
            className={sharedStyles['menu-link']}
            onClick={() => trackNavigate({ navigate_to: href })}
          >
            <Text
              font="a"
              size={10}
              className={headerClasses}
            >
              { header }
            </Text>
          </LinkWrapper>
        ) : (
          <div
            onClick={() => setActivePrimaryTab(activeName)}
          >
            <Text
              font="a"
              type={10}
              className={headerClasses}
              id={header.replace(/(\W|\s)/g, '-')}
            >
              { header }
            </Text>
          </div>
        )
      }
      {
        submenu &&
          <Submenu
            subMenuSecondaryBackground={subMenuSecondaryBackground} // Experiment CH28357 -- Remove this line if experiment loses
            submenuItems={submenu}
            isActive={activeName === activePrimaryTab}
            activeName={activeName}
            {...otherProps}
          />
      }
    </React.Fragment>
  );
}

PrimaryMenuHeader.propTypes = {
  activePrimaryTab: PropTypes.string,
  setActivePrimaryTab: PropTypes.func,
  activeName: PropTypes.string,
  header: PropTypes.string,
  submenu: PropTypes.array,
  subMenuSecondaryBackground: PropTypes.bool, // Experiment CH28357 -- Remove this line if experiment loses
};

export default PrimaryMenuHeader;



// WEBPACK FOOTER //
// ../src/templates/MainNav/Menu/PrimaryMenuHeader/index.js